
import { TYPES } from '@/core/config/Types';
import { FindAllContainers } from '@/settings/application/uses_cases/containers/search/FindAllContianers';
import { ConceptsContainer } from '@/settings/domain/containers/conceptsContainer/ConceptsContainer';
import { Containers } from '@/settings/domain/containers/Containers';
import { Inject } from 'inversify-props';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import FooterModal from './FooterModals/FooterModal.vue';
import HeaderModal from './HeaderModals/HeaderModal.vue';

@Component({
  name: 'ModalC9',
  components: { HeaderModal, FooterModal }
})
export default class ModalC9 extends Vue {
  @Inject(TYPES.FIND_ALL_CONTAINERS)
  readonly findAllContainers!: FindAllContainers;

  @Prop() switchId!: string;
  @Prop() switchDescription!: string;
  @Prop() eventDescription!: string;
  @Prop() activityDescription!: string;
  @Prop() sendNotification!: boolean;
  @Prop() idModal!: string;
  @Prop({ type: Function }) saveProcess!: any;

  isLoading = false;
  containers: Containers[] = [];
  containerSelected: Containers | null = null;

  created() {
    this.findContainers();
  }

  customContainerLabel(container: Containers) {
    return `${container.id} - ${container.description}`;
  }

  evaluationOptions(concept: ConceptsContainer) {
    return concept.evaluationMethod === 'value'
      ? JSON.parse(concept.listValues.toString())
      : JSON.parse(concept.listConceptual.toString());
  }

  async findContainers() {
    try {
      this.isLoading = true;

      const allContainers = await this.findAllContainers.execute();
      if ('error' in allContainers || 'message' in allContainers) {
        this.isLoading = false;
        return;
      }

      this.containers = allContainers.filter((container: Containers) => container.conceptsContainer.length > 0);
      this.isLoading = false;
    } catch (error) {
      this.isLoading = false;
      throw new Error(`${error}`);
    }
  }
}
